<template>
  <div>
    <spin v-if="is_loading" fix size="large" />
    <router-view v-if="!is_loading" />
  </div>
</template>

<script>
  /**
   * Это Обертка для Layout.
   * Нам пригодится использовать несколько шаблонов для "Авторизованного пользоватя",
   * но в каждом выполнять одинаковые проверки. Этот компонент сделан для этого
   */
  import { CRM_URL } from '@shared/helpers/env';
  import { mapActions, mapGetters } from 'vuex';
  import { Noty } from '@/plugins/vue-noty';
  import { Notification } from '@notify/models/notification';

  export default {
    data: () => ({
      is_loading: true
    }),

    async created() {
      if (this.$router.history._startLocation.indexOf('service=crm') != -1) {
        window.location.href = `${CRM_URL}administration/integration?token=${this.token}`;
      }
      try {
        await this.syncFullProfile();
        this.getNotifications();
      } catch (e) {
        if (e.response.status !== 401) {
          console.error('Error on ME method', e);
          await this.$store.dispatch('core/auth/logout');
          this.$router.push({ name: 'auth.login' });
        }
      } finally {
        this.is_loading = false;
      }
    },
    computed: {
      ...mapGetters('core/auth', ['token', 'user'])
    },
    mounted() {
      /**
       * При hot-reload падает исключение.
       * При обычных переходах все нормально
       * TODO :: https://github.com/probil/vue-socket.io-extended/issues/431
       */
      try {
        this.$socket.client.on(`zrr.notify.notifications:${this.$user.user_key}`, (payload) => {
          const { data } = payload;
          const group = data.group;

          if (group !== 'client') return false;

          this.$store.dispatch('notify/notifications/last/getAsyncData').then(() => {
            const notification_item = new Notification(data);

            new Noty({
              closeWith: ['click'],
              callbacks: {
                onClick: () => {
                  this.$store.dispatch('notify/notifications/last/readOne', data.id);
                }
              },
              text: notification_item.getText(),
              type: notification_item.getTheme()
            }).show();

            /**
             *
             * Popup для HLR
             *
             */

            if (data.type === 'not_enough_money') {
              this.$noty.popup(data.params?.file_name);
            }
          });
        });
      } catch (e) {
        console.log('CATCH from TRY Subscribe Noty');
        // catch для hot-reload
      }
    },

    methods: {
      ...mapActions('core/auth', ['syncFullProfile']),
      ...mapActions('notify/notifications/last', { getNotifications: 'getAsyncData' })
    }
  };
</script>
